import {
  SectorListItem,
  SectorTask,
  SectorTaskGroupings,
  TaskGroupListItem,
} from '@app/domain';
import { PaginatedResponse } from '@app/shared/models/global.model';
import {
  SectorListItemDTO,
  SectorTaskDTO,
  SectorTaskGroupingsDTO,
  TaskGroupListItemDTO,
} from '../dtos';

export class SectorMapper {
  sectorListToDomain(
    dto: PaginatedResponse<SectorListItemDTO>
  ): PaginatedResponse<SectorListItem> {
    return {
      data: dto.data.map(dtoItem => ({
        id: dtoItem.id,
        sectorName: dtoItem.sectorName,
        sectorType: dtoItem.sectorType,
        sectorStatus: dtoItem.sectorStatus,
        sectorCreatedBy: dtoItem.sectorCreatedBy,
        sectorUpdatedByUsername: dtoItem.sectorUpdatedByUsername,
        sectorCreatedByUsername: dtoItem.sectorCreatedByUsername,
        sectorCreatedAt: dtoItem.sectorCreatedAt,
        sectorConfig: dtoItem.sectorConfig,
        berthList: dtoItem.berthList,
        isActive: dtoItem.isActive,
      })),
      page: dto.page,
      size: dto.size,
      totalElements: dto.totalElements,
      totalPages: dto.totalPages,
    };
  }

  sectorDetailToDomain(dto: SectorTaskGroupingsDTO): SectorTaskGroupings {
    return {
      sector: {
        id: dto.sector.id,
        sectorName: dto.sector.sectorName,
        sectorType: dto.sector.sectorType,
        sectorStatus: dto.sector.sectorStatus,
        sectorCreatedBy: dto.sector.sectorCreatedBy,
        sectorCreatedAt: dto.sector.sectorCreatedAt,
        berthList: dto.sector.berthList,
      },
      taskGroupList: dto.taskGroupList.map(item =>
        this.taskGroupListItemToDomain(item)
      ),
    };
  }

  taskGroupListItemToDomain(dto: TaskGroupListItemDTO): TaskGroupListItem {
    return {
      taskGroup: {
        id: dto.taskGroup.id,
        sectorId: dto.taskGroup.sectorId,
        taskGroupTypeName: dto.taskGroup.taskGroupTypeName,
        taskGroupTypeId: dto.taskGroup.taskGroupTypeId,
      },
      taskTemplateList: dto.taskTemplateList.map(item =>
        this.taskTemplateListItemToDomain(item)
      ),
    };
  }

  taskTemplateListItemToDomain(dto: SectorTaskDTO): SectorTask {
    return {
      id: dto.id,
      templateName: dto.templateName,
      hasDependence: dto.hasDependence,
      createdAt: dto.createdAt,
    };
  }

  sectorListItemToDomain(dto: SectorListItemDTO): SectorListItem {
    return {
      id: dto.id,
      sectorName: dto.sectorName,
      sectorType: dto.sectorType,
      sectorStatus: dto.sectorStatus,
      sectorCreatedBy: dto.sectorCreatedBy,
      sectorUpdatedByUsername: dto.sectorUpdatedByUsername,
      sectorCreatedByUsername: dto.sectorCreatedByUsername,
      sectorCreatedAt: dto.sectorCreatedAt,
      sectorConfig: dto.sectorConfig,
      berthList: dto.berthList,
      isActive: dto.isActive,
    };
  }
}
